<template>
    <div class="user-row" :class="classes" @click="actionClick">
        <div class="circle">
            <div class="circle-mark"></div>
        </div>
        <span v-text="username"></span>
        <span v-text="fullName"></span>
    </div>
</template>

<script>

    export default {
        name: "AdminAccountPairUser",
        props: {
            user: {
                type: Object,
                required: true,
            }
        },
        computed: {
            classes() {
                return {
                    'active': this.active,
                }
            },
            id() {
                return this.user.id ?? 0;
            },
            username() {
                return this.user.username ?? '';
            },
            firstName() {
                return this.user.first_name ?? '';
            },
            lastName() {
                return this.user.last_name ?? '';
            },
            fullName() {
                return '(' + this.firstName + ' ' + this.lastName + ')';
            },
            active() {
                return this.$parent.$parent.activeUserId === this.id;
            }
        },
        methods: {
            actionClick() {
                this.$parent.$parent.activeUserId = this.id;
            }
        }
    }
</script>